import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { yesNoItems } from '@core/form-generator-engine/helpers/yes-no-items';
import { YesNoItem } from '@core/form-generator-engine/typing/yes-no-item';

@Component({
  standalone: false,
  selector: 'gstar-yes-no',
  templateUrl: './yes-no.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class YesNoComponent implements OnInit {
  @Input() value!: boolean;

  options: YesNoItem[] = yesNoItems;
  selected?: YesNoItem;

  ngOnInit(): void {
    this.selected = this.options.find(
      (item: YesNoItem) => item.value === this.value
    );
  }
}
